module.exports = "<h2 class=\"title\">Entenda os limites Pix</h2>\n<p>\n\tSuas transações via Pix estão limitadas em no máximo R$ 2.000,00 por dia e R$ 5.000,00 por mês independente dos valores das transações.\n</p>\n<p>\n\tCaso você ultrapasse esse limite, aguarde o próximo mês para transacionar ou solicite um aumento de limite máximo.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/limits/understand/understand.component.html
// module id = ../../../../../src/app/master/pix/limits/understand/understand.component.html
// module chunks = main